import React from 'react';
import FundingSequenceBoard from './FundingSequenceBoard';

const FundingSequenceDetailPanel = (props) => <FundingSequenceBoard {...props} />;

export default FundingSequenceDetailPanel;
